import { render } from "./VisionAndMission.vue?vue&type=template&id=22398703&scoped=true"
import script from "./VisionAndMission.vue?vue&type=script&lang=js"
export * from "./VisionAndMission.vue?vue&type=script&lang=js"

import "./VisionAndMission.vue?vue&type=style&index=0&id=22398703&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22398703"]])

export default __exports__